import { Stack } from 'react-bootstrap'
import { BsXLg } from 'react-icons/bs'

import { Button } from '@piv/portal/primitives/Buttons'

import { useInventoryFilterParams } from './useInventoryFilterParams'

interface Props {
  id: string
}

export function ClearFiltersButtonRow({ id }: Readonly<Props>) {
  const { resetFilters, isAnyFilterSet, validFilterCount } =
    useInventoryFilterParams()

  return (
    <Stack direction="horizontal">
      <span className="p2">
        {!isAnyFilterSet ? 'No' : validFilterCount} filter
        {validFilterCount > 1 || !isAnyFilterSet ? 's' : ''} set
      </span>
      <Button
        icon={<BsXLg />}
        onClick={resetFilters}
        disabled={!isAnyFilterSet}
        id={id}
        className="p2 ms-auto"
      >
        Clear
      </Button>
    </Stack>
  )
}
